module.exports = __webpack_public_path__ + "static/media/mushroom_group.bf5fd777.png";